/**
 *
 * OfferCard
 *
 */

import React from "react";
import PropTypes from "prop-types";
import {
  IntlPropType,
  trackContentInteraction,
  getUtfAddOnString,
} from "root/libs/core-libs/src";
import {
  keys,
  businessUnits,
  UTF_EVENT_CONTENT_NAMES,
  UTF_EVENT_TYPES,
  UTF_EVENT_INTERACTIONS,
  UTF_EVENT_CONTENT_POSITION,
  UTF_EVENT_CONVERSION_NAMES,
  UTF_EVENT_CONVERSION_TYPES,
  UTF_EVENT_CONVERSION_DETAIL,
} from "root/libs/constants/src";
import { selectTrackingKey } from "one-time-shipment/src/containers/Tracking/selectors";
import { Sizes, Variants } from "@dhl-official/stencil-library";
import { SEGMENT_TYPES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import { CountrySettings } from "root/libs/ui-containers/src";
import { Icon } from "root/libs/ui-components/src";
import WCCMultiBUOfferPriceAndPaymentInfo from "one-time-shipment/src/components/Offers/WCCMultiBUOfferPriceAndPaymentInfo";
import WCCOfferAdditionalTimings from "one-time-shipment/src/components/Offers/WCCOfferAdditionalTimings";
import AdditionalInformation from "one-time-shipment/src/components/Offers/AdditionalInformation";
import OfferAddOns from "one-time-shipment/src/components/Offers/OfferAddOns";
import OfferProperties from "one-time-shipment/src/components/Offers/OfferProperties";
import OfferCardDropdown from "one-time-shipment/src/components/Offers/OfferCardDropdown";
import OfferPromotedLine from "one-time-shipment/src/components/Offers/OfferPromotedLine";
import WCCMultiBUOfferDeliveryInfo from "one-time-shipment/src/components/Offers/WCCMultiBUOfferDeliveryInfo";
import WCCMultiBUOfferPriceBreakdown from "one-time-shipment/src/components/Offers/WCCMultiBUOfferPriceBreakdown";
import SpecialOfferInfo from "one-time-shipment/src/components/Offers/SpecialOfferInfo";
import WCCOfferCardInformation from "one-time-shipment/src/components/Offers/WCCOfferCardInformation";
import GfOceanIcon from "iconsTwoColors/cx/DHL_OceanFreight.svg";
import GfAirIcon from "iconsTwoColors/cx/DHL_AirFreight.svg";
import GfOceanAirIcon from "iconsTwoColors/cx/DHL_OceanAirFreight.svg";
import freightIcon from "iconsTwoColors/cx/DHL_RoadFreight.svg";
import expressIcon from "iconsTwoColors/cx/DHL_Express.svg";
import PnPOffersIcon from "iconsTwoColors/cx/DHL_PnPOffers.svg";
import parcelIcon from "iconsTwoColors/cx/DHL_Parcel_reduced.svg";
import {
  StyledOfferCard,
  StyledPriceContainer,
  StyledCTAWrapper,
  StyledEstimatedDeliveryText,
  StyledEstimatedDeliveryInfo,
  OfferCardContent,
  StyledAccordion,
  OfferCardDetailsContent,
  DeliveryInfoContent,
  DeliveryInfoWrapper,
  StyledAdditionalOfferDetails,
  ContentWrapper,
  OfferWrapper,
  StyledQuoteValidity,
} from "./styled";
import { BusinessUnitName } from "../OfferDeliveryInfo/styled";
import AccountPricingCard from "../AccountPricingCard";

const { withCountry } = CountrySettings;

const COPY_ID_PREFIX = "WCCOfferCard";

export default class WCCOfferCard extends React.PureComponent {
  static propTypes = {
    /** Internationalization library */
    intl: IntlPropType.isRequired,
    purchaseMethod: PropTypes.string,
    isBusiness: PropTypes.bool,
    showCurrencyIsoCodeForPrices: PropTypes.bool,
    offerIndex: PropTypes.number,
    offer: PropTypes.object,
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
    nativeLanguageCode: PropTypes.string,
    is12HourTimeFormat: PropTypes.bool,
    nativeDateTimeFormat: PropTypes.string,
    isExpanded: PropTypes.bool,
    expandedCardIndex: PropTypes.number,
    onCardClick: PropTypes.func,
    trackEvent: PropTypes.func,
    indexLength: PropTypes.number,
    reference: PropTypes.object,
    destinationField: PropTypes.object,
    formatCurrencyWithNativeLocale: PropTypes.bool,
    toggleFreightP2PModal: PropTypes.func,
  };

  static defaultProps = {
    onCardClick: () => {},
    trackEvent: () => {},
    reference: { current: null },
  };

  constructor(props) {
    super(props);
    this.WCCMultiBUOfferPriceAndPaymentInfoWithCountry = withCountry(
      WCCMultiBUOfferPriceAndPaymentInfo
    );
    this.OfferPropertiesWithCountry = withCountry(OfferProperties);
    this.OfferAddOnsWithCountry = withCountry(OfferAddOns);
    this.OfferPromotedLineWithCountry = withCountry(OfferPromotedLine);
    this.OfferCardDropdownWithCountry = withCountry(OfferCardDropdown);
    this.trackingKeySelector = selectTrackingKey;
    this.idExploredOfferTrackingKeyPath = this.trackingKeySelector(
      "spotShipment.interactions.offer.idExploredOffer"
    );
    this.state = {
      isAccordionOpen: false,
    };
    this.priceBreakdown = React.createRef();
    this.offerAddOnsRef = React.createRef();
  }

  getCopy = (id) => {
    const { intl } = this.props;
    return intl.formatMessage(
      { id },
      {
        br: <br key="br" />,
      }
    );
  };

  getOfferTypeIcon = (key, businessUnit) => {
    // Fallback when businessUnit is not provided.
    if (
      typeof businessUnit === "undefined" &&
      key.includes(businessUnits.EXPRESS)
    ) {
      return expressIcon;
    }

    switch (businessUnit) {
      case businessUnits.DGF:
        if (key.includes("OFR")) {
          return GfOceanIcon;
        }
        if (key.includes("AFR")) {
          return GfAirIcon;
        }
        return GfOceanAirIcon;
      case businessUnits.FREIGHT:
        return freightIcon;
      case businessUnits.EXPRESS:
        return expressIcon;
      case businessUnits.PNP:
        return PnPOffersIcon;
      default:
        return parcelIcon;
    }
  };

  getPromotedProperty = (displayOffer) => {
    if (Array.isArray(displayOffer.properties)) {
      return displayOffer.properties
        .filter((property) => property.promoted === true)
        .pop();
    }
    return undefined;
  };

  showAdditionalInformation = () => {
    const { offer } = this.props;

    return (
      Array.isArray(offer.additionalInformation) &&
      offer.additionalInformation.length > 0
    );
  };

  showECSInfoMessage = () => {
    const { offer } = this.props;

    const { information } = offer;

    return (
      information &&
      information.find((element) => element.category === "INFO") &&
      information.find(
        (element) => element.header !== "PALLET_REQUIRED_INFORMATION"
      )
    );
  };

  onCardClick = () => {
    const { offer, onCardClick } = this.props;

    onCardClick({ ...offer });
  };

  onKeyDown = (event) => {
    // Only react when the card itself has focus — not when the key event
    // bubbles up from a nested actionable element (e.g. the "Schedule a Pick
    // Up" button or the "Details and Add-Ons" accordion trigger), so we
    // don't hijack or double-fire their built-in Enter/Space handling.
    if (event.target !== event.currentTarget) {
      return;
    }
    const { code } = event;
    if (code === keys.RETURN || code === keys.SPACE) {
      event.preventDefault();
      // Toggle the details accordion by clicking its trigger button. This
      // routes through the underlying Accordion's own click handler, which
      // updates its internal `activeIndex` AND invokes `onTitleClick`
      // (this.onClickOffersDetailsAccordion), keeping visual state and
      // `isAccordionOpen` / tracking in sync.
      const { purchaseMethod, offerIndex } = this.props;
      const trigger = document.querySelector(
        `button[data-testid="expand-collapse-${purchaseMethod.toLowerCase()}-${offerIndex}"]`
      );
      if (trigger) {
        trigger.click();
      }
    }
  };

  onClickOffersDetailsAccordion = () => {
    const { trackEvent, isBusiness, offer } = this.props;
    const { isAccordionOpen } = this.state;
    const key = offer?.key;

    trackEvent({ idExploredOffer: key });

    if (!isAccordionOpen) {
      trackContentInteraction({
        name: UTF_EVENT_CONTENT_NAMES.EXPAND_CARD,
        type: UTF_EVENT_TYPES.BUTTON,
        interaction: UTF_EVENT_INTERACTIONS.CLICK,
        position: UTF_EVENT_CONTENT_POSITION.PRODUCT_CARD,
        context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
        attributes: { key },
      });
    }

    this.setState({ isAccordionOpen: !isAccordionOpen });
  };

  getRef = (ref) => {
    this.priceBreakdown = ref;
  };

  focusPriceBreakdown = () => {
    const { offerIndex, purchaseMethod } = this.props;
    const { isAccordionOpen } = this.state;
    if (this.priceBreakdown && this.priceBreakdown.current) {
      let timeout = 0;
      if (!isAccordionOpen) {
        document
          .querySelector(
            `button[data-testid=expand-collapse-${purchaseMethod.toLowerCase()}-${offerIndex}]`
          )
          .click();
        timeout = 300;
      }

      setTimeout(() => {
        const headerOffset = 300;
        const elementPosition = this.priceBreakdown.current.getBoundingClientRect()
          .top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }, timeout);
    }
  };

  render() {
    const {
      intl,
      purchaseMethod,
      isBusiness,
      showCurrencyIsoCodeForPrices,
      offerIndex,
      offer,
      isFirst,
      isLast,
      nativeLanguageCode,
      is12HourTimeFormat,
      nativeDateTimeFormat,
      isExpanded,
      expandedCardIndex,
      indexLength,
      reference,
      destinationField,
      formatCurrencyWithNativeLocale,
      toggleFreightP2PModal,
    } = this.props;

    const displayOffer = offer;
    const promotedProperty = this.getPromotedProperty(displayOffer);
    const additionalInfoECSMessage = this.showECSInfoMessage();
    const priceBreakdownId = `price-breakdown`;

    const multiBUId = `${purchaseMethod.toLowerCase()}-${offerIndex}`;

    const offerTypeIcon = this.getOfferTypeIcon(
      displayOffer.key,
      displayOffer.businessUnit
    );

    const ariaLabelledBy = `
         EXP_DOMESTIC_ENDOFDAY_WALK-firstline 
         wcc-offer-card-date-${multiBUId} 
         wcc-offer-card-estimated-delivery-guarantee-${multiBUId} 
         wcc-offer-card-additional-timings-${multiBUId} 
         ${displayOffer.key}-delivery-info 
         promoted-addon-${multiBUId} 
         ${displayOffer.key}-price
       `;
    const accordionId = `wcc-offer-card-accordion-${multiBUId}`;

    const destinationCountry = destinationField.fields?.country?.value?.value;

    const { isAccordionOpen } = this.state;

    let finalAdditionalInfoList =
      Array.isArray(displayOffer.additionalInformation) &&
      displayOffer.additionalInformation.length > 0
        ? displayOffer.additionalInformation
        : [];

    if (additionalInfoECSMessage) {
      finalAdditionalInfoList = [
        ...finalAdditionalInfoList,
        ...[{ key: additionalInfoECSMessage.message }],
      ];
    }

    const shippingModesString = getUtfAddOnString(displayOffer.addOns);

    const deliveryInfoExists = !!intl.messages[
      `${COPY_ID_PREFIX}.${purchaseMethod}_deliveryInfo`
    ];

    const isSpecialOffer = !!(
      typeof offer.specialOffers !== "undefined" &&
      offer.specialOffers.length > 0
    );

    const netPrice = displayOffer.price?.billingTaxAmount
      ? displayOffer?.price?.billingAmount -
        displayOffer?.price?.billingTaxAmount
      : displayOffer?.price?.billingAmount;

    const getBusinessUnitCopy = (key, businessUnit) => {
      const businessUnitMap = {
        [businessUnits.DGF]: "QuoteValidity.DGF",
        [businessUnits.FREIGHT]: "QuoteValidity.FREIGHT",
        [businessUnits.ECS]: "QuoteValidity.ECS",
        [businessUnits.EXPRESS]: "QuoteValidity.EXP",
        [businessUnits.PNP]: "QuoteValidity.PNP",
      };

      // Determine if the fallback should be used
      if (
        typeof businessUnit === "undefined" &&
        key.includes(businessUnits.EXPRESS)
      ) {
        return "QuoteValidity.EXP";
      }

      return businessUnitMap[businessUnit] || "QuoteValidity.EXP";
    };

    const moreInfoId = `${displayOffer.key}-moreInfo`;
    const moreInfoMsgId = `${COPY_ID_PREFIX}.screenReaderLabel_moreInformation`;
    const rawMoreInfo = intl.formatMessage({
      id: moreInfoMsgId,
      defaultMessage: "",
    });
    const moreInfoText =
      rawMoreInfo && rawMoreInfo.trim() !== moreInfoMsgId ? rawMoreInfo : "";

    return (
      <OfferWrapper className="grid-maxWidth">
        <StyledOfferCard
          key={`offer-${purchaseMethod}`}
          isFirst={isFirst}
          isLast={isLast}
          isExpanded={isExpanded}
          expandedCardIndex={expandedCardIndex}
          offerIndex={offerIndex}
          iAmExpanded={offerIndex === expandedCardIndex}
          data-testid={`wcc-offer-card-${multiBUId}`}
          aria-label={intl.formatMessage(
            { id: `${COPY_ID_PREFIX}.screenReaderLabel_offersAmount` },
            {
              currentOfferIndex: offerIndex + 1,
              totalOffersAmount: indexLength,
            }
          )}
          tabIndex={0}
          aria-labelledby={ariaLabelledBy}
          aria-expanded={isAccordionOpen}
          aria-controls={`${accordionId}-content`}
          onKeyDown={this.onKeyDown}
        >
          <OfferCardContent
            iAmExpanded={offerIndex === expandedCardIndex}
            expandedCardIndex={expandedCardIndex}
          >
            <DeliveryInfoContent>
              <DeliveryInfoWrapper>
                <Icon
                  icon={offerTypeIcon}
                  width={{
                    mobile: "72px",
                    desktop: "72px",
                  }}
                  height={{
                    mobile: "52px",
                    desktop: "52px",
                  }}
                  useAs="decorative"
                />
                <ContentWrapper>
                  {isSpecialOffer ? (
                    <SpecialOfferInfo
                      offer={offer}
                      purchaseMethod={purchaseMethod}
                      offerIndex={multiBUId}
                      textSize={Sizes.XS}
                    />
                  ) : (
                    <React.Fragment>
                      <StyledEstimatedDeliveryText
                        isLast={isLast}
                        isFirst={isFirst}
                        expandedCardIndex={expandedCardIndex}
                        size={Sizes.XS}
                        iAmExpanded={offerIndex === expandedCardIndex}
                        id={`${displayOffer.key}-firstline`}
                        isParagraph
                        dataTestid={`wcc-offer-card-estimated-delivery-text-${multiBUId}`}
                      >
                        {this.getCopy(
                          displayOffer.deliveryType === "COMMITTED"
                            ? "CardAndSummary.committedDelivery"
                            : "CardAndSummary.estimatedDelivery"
                        )}
                      </StyledEstimatedDeliveryText>
                      <WCCMultiBUOfferDeliveryInfo
                        intl={intl}
                        displayOffer={displayOffer}
                        offerIndex={multiBUId}
                        offerType={offerIndex}
                        offer={offer}
                        estimatedDeliveryTime={
                          displayOffer.estimatedDeliveryTime
                        }
                        nativeDateTimeFormat={nativeDateTimeFormat}
                        estimatedDeliveryTimeDisplayType={
                          displayOffer.estimatedDeliveryTimeDisplayType
                        }
                        is12HourTimeFormat={is12HourTimeFormat}
                        nativeLanguageCode={nativeLanguageCode}
                        offerId={displayOffer.id}
                        variationType="WCCMultiBUOfferCard"
                      />
                      {displayOffer.businessUnit === "EXP" && (
                        <WCCOfferAdditionalTimings
                          intl={intl}
                          offerIndex={multiBUId}
                          offerId={displayOffer.id}
                          useFallback
                          isMultiBU
                        />
                      )}
                    </React.Fragment>
                  )}
                  {deliveryInfoExists && (
                    <StyledEstimatedDeliveryInfo
                      isLast={isLast}
                      isFirst={isFirst}
                      expandedCardIndex={expandedCardIndex}
                      iAmExpanded={offerIndex === expandedCardIndex}
                      id={`${displayOffer.key}-delivery-info`}
                      isParagraph
                      dataTestid={`wcc-offer-card-estimated-delivery-info-${offerIndex}`}
                      size={Sizes.XS}
                    >
                      {this.getCopy(
                        `${COPY_ID_PREFIX}.${purchaseMethod}_deliveryInfo`
                      )}
                    </StyledEstimatedDeliveryInfo>
                  )}
                  {promotedProperty && !isSpecialOffer && (
                    <StyledCTAWrapper>
                      <this.OfferPromotedLineWithCountry
                        offerKey={displayOffer.key}
                        cutOffDateTime={displayOffer.cutOffDateTime}
                        intl={intl}
                        offerIndex={multiBUId}
                        promotedProperty={promotedProperty}
                        pickUpDate={displayOffer.pickUpDate}
                        iNeedTheseProps={[
                          "is12HourTimeFormat",
                          "nativeLanguageCode",
                          "nativeDateTimeFormat",
                        ]}
                        purchaseMethod={purchaseMethod}
                      />
                    </StyledCTAWrapper>
                  )}
                  <WCCOfferCardInformation
                    id={`${displayOffer.key}-wcc-information`}
                    offerKey={displayOffer.key}
                    businessUnit={offer.businessUnit}
                    purchaseMethod={purchaseMethod}
                    intl={intl}
                    offerIndex={multiBUId}
                    locatorLink={displayOffer.locatorLink}
                    isBusiness={isBusiness}
                    copyPrefix="WCCMultiBUOfferCardInformation"
                    offer={offer}
                  />
                  <BusinessUnitName
                    data-testid={`offer-operated-by-${displayOffer.key}`}
                  >
                    {intl.formatMessage(
                      { id: "QuoteValidity.operatedBy" },
                      {
                        businessUnit: intl.formatMessage({
                          id: getBusinessUnitCopy(
                            displayOffer.key,
                            displayOffer.businessUnit
                          ),
                        }),
                      }
                    )}
                  </BusinessUnitName>
                </ContentWrapper>
              </DeliveryInfoWrapper>
            </DeliveryInfoContent>
            <StyledPriceContainer
              isFirst={isFirst}
              isLast={isLast}
              expandedCardIndex={expandedCardIndex}
              iAmExpanded={offerIndex === expandedCardIndex}
            >
              <this.WCCMultiBUOfferPriceAndPaymentInfoWithCountry
                priceBreakdownAnchor={this.focusPriceBreakdown}
                priceBreakdownRef={priceBreakdownId}
                accordionAnchor={`expand-collapse-${multiBUId}`}
                displayOffer={displayOffer}
                purchaseMethod={purchaseMethod}
                key={displayOffer.id}
                offerIndex={multiBUId}
                intl={intl}
                offer={displayOffer}
                isBusiness={isBusiness}
                showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
                toggleFreightP2PModal={toggleFreightP2PModal}
                iNeedTheseProps={[
                  "formatCurrencyWithNativeLocale",
                  "isExpressAllowedOnMobile",
                ]}
                nativeLanguageCode={nativeLanguageCode}
                utfDataObject={{
                  conversion: {
                    name: UTF_EVENT_CONVERSION_NAMES.BOOKING_INTENT,
                    type: UTF_EVENT_CONVERSION_TYPES.HANDOVER,
                    detail: UTF_EVENT_CONVERSION_DETAIL[purchaseMethod],
                  },
                  products: [
                    {
                      id: displayOffer.id,
                      key: displayOffer.key,
                      businessUnit: displayOffer.businessUnit,
                      price: displayOffer.price.amount,
                      currency: displayOffer.price.currencyCode,
                      shippingModes: shippingModesString,
                      netPrice,
                    },
                  ],
                  content: {
                    name: UTF_EVENT_CONTENT_NAMES.CONTINUE_TO_BOOKING,
                    type: UTF_EVENT_TYPES.BUTTON,
                    interaction: UTF_EVENT_INTERACTIONS.CLICK,
                    position: UTF_EVENT_CONTENT_POSITION.PRODUCT_CARD,
                    context: isBusiness
                      ? SEGMENT_TYPES.business
                      : SEGMENT_TYPES.private,
                  },
                }}
              />
            </StyledPriceContainer>
          </OfferCardContent>
          {offer.priceFrequentShipper && isBusiness && (
            <AccountPricingCard
              {...{
                formatCurrencyWithNativeLocale,
                intl,
                nativeLanguageCode,
                offer,
                offerIndex,
                showCurrencyIsoCodeForPrices,
              }}
            />
          )}
          {moreInfoText && (
            <span id={moreInfoId} className="visually-hidden">
              {moreInfoText}
            </span>
          )}
          <StyledAccordion
            expandCollapseButtonVariation="bubbleWithText"
            expandCollapseButtonTestId={`expand-collapse-${multiBUId}`}
            expandButtonLabel={intl.formatMessage({
              id: `OfferCardHorizontal.exploreOffer`,
            })}
            collapseButtonLabel={intl.formatMessage({
              id: `OfferCardHorizontal.closeOffer`,
            })}
            expandButtonAriaLabel={intl.formatMessage({
              id: `OfferCardHorizontal.screenReaderLabel_ariaExploreOffer`,
            })}
            collapseButtonAriaLabel={intl.formatMessage({
              id: `OfferCardHorizontal.screenReaderLabel_ariaCloseOffer`,
            })}
            buttonVariant={Variants.text}
            expandButtonAriaControls={`${accordionId}-content`}
            expandButtonDataTracking={this.idExploredOfferTrackingKeyPath}
            onTitleClick={this.onClickOffersDetailsAccordion}
          >
            <StyledAccordion.Trigger
              ariaControls={`${accordionId}-content`}
              ref={reference}
            />
            <StyledAccordion.Content
              id={`${accordionId}-content`}
              labeledBy={`${accordionId}-title`}
              className="offerCollapsibleContent"
            >
              <OfferCardDetailsContent>
                <div>
                  <this.OfferPropertiesWithCountry
                    properties={displayOffer.properties}
                    offerId={displayOffer.key}
                    estimatedDeliveryTime={displayOffer.estimatedDeliveryTime}
                    intl={intl}
                    iNeedTheseProps={["is12HourTimeFormat"]}
                    variationType="WCCMultiBUOfferCard"
                  />
                </div>
                <this.OfferAddOnsWithCountry
                  trackEvent={() => {}}
                  addOns={displayOffer.addOns}
                  offerKey={displayOffer.key}
                  intl={intl}
                  isOverAllAccordianOpen={isAccordionOpen}
                  ref={this.offerAddOnsRef}
                  iNeedTheseProps={[
                    "nativeLanguageCode",
                    "formatCurrencyWithNativeLocale",
                  ]}
                  variationType="WCCMultiBUOfferCard"
                />
              </OfferCardDetailsContent>
              <StyledAdditionalOfferDetails>
                {(this.showAdditionalInformation() ||
                  additionalInfoECSMessage) && (
                  <AdditionalInformation
                    intl={intl}
                    additionalInformationList={finalAdditionalInfoList}
                    businessUnit={displayOffer.businessUnit}
                    bussinessUnitKey={displayOffer.key}
                    isStaticOffer={!!isSpecialOffer}
                    destinationCountry={destinationCountry}
                  />
                )}
                {isBusiness && (
                  <WCCMultiBUOfferPriceBreakdown
                    id={priceBreakdownId}
                    offerIndex={multiBUId}
                    offer={displayOffer}
                    intl={intl}
                    showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
                    nativeLanguageCode={nativeLanguageCode}
                    iNeedTheseProps={["formatCurrencyWithNativeLocale"]}
                    getRef={this.getRef}
                  />
                )}
              </StyledAdditionalOfferDetails>
              <StyledQuoteValidity
                businessUnit={displayOffer.businessUnit}
                variationType="WCCMultiBUOfferCard"
              />
            </StyledAccordion.Content>
          </StyledAccordion>
        </StyledOfferCard>
      </OfferWrapper>
    );
  }
}
